module.exports = __webpack_public_path__ + "static/img/rank_15.04acd7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_15.png
// module id = vK+7
// module chunks = 0